import { useQuery } from '@tanstack/react-query'
import type { AgentConfiguration } from '@multiplayer-app/ai-agent-types'
import { useAgentRuntime } from '../context/AgentProvider'

export const useAgentConfigurations = (contextKey?: string) => {
  const runtime = useAgentRuntime()

  return useQuery({
    queryKey: ['mp-agents', 'configurations', contextKey ?? 'all'],
    queryFn: async (): Promise<AgentConfiguration[]> => {
      if (!runtime.transport.listAgentConfigurations) {
        return []
      }
      return runtime.transport.listAgentConfigurations(contextKey)
    },
    staleTime: 60_000,
    refetchOnWindowFocus: false
  })
}
